// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__+DwXS","vertical":"Divider_vertical__3BNyo"};